import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { BranchSelectorProps } from "~/areas/projects/components/BranchSelector/BranchSelector";
import { BranchSelector } from "~/areas/projects/components/BranchSelector/BranchSelector";
import { ProjectCreatePullRequestLink } from "../ProjectCurrentBranchDisplay/ProjectCreatePullRequestLink";
export function PageHeaderBranchSelector({ project, gitRef, setGitRef }: BranchSelectorProps) {
    if (!project.IsVersionControlled)
        return null;
    return (<div className={branchSelectorContainer}>
            <BranchSelector project={project} gitRef={gitRef} setGitRef={setGitRef}/>
            <ProjectCreatePullRequestLink project={project} gitRef={gitRef}/>
        </div>);
}
const branchSelectorContainer = css({
    display: "flex",
    gap: space[16],
    alignItems: "center",
});
